export default data => {
    const { DescripcionInferior, DescripcionSuperior, UrlImagen, Metadata } = data.CompraMobileViewModel;

    return {
        title: DescripcionSuperior,
        description: DescripcionInferior,
        image: UrlImagen,
        metadata: Metadata
    }
};